<template>
	<div>
		<el-tooltip effect="dark" placement="right" popper-class="tip-class">
			<div slot="content">
				1、订单商品数量：订单详情页中主订单明细中的数量，随着订单状态变化数量会实时发生变化，如订货数量为10，发货数量为9，则此时订单商品数量为9（注：手动退单数量不会计入订单商品数量，需在退单商品数量统计）<br/>
				2、已取消的订单不计入统计<br/>
				3、订单商品金额为营销活动优惠后的金额，即实付额<br/>
				4、订货数量/金额、发货数量/金额、收货数量/金额取当时订单状态的数量/金额，订单状态改变后不会发生变化<br/>
				5、订单中商品、客户属性为下单时记录的商品、客户属性，后续更改不会改变订单下单时记录；如下单时客户名称为张三，下单后修改为李四，此时报表记录为张三不会修改为李四<br/>
			</div>
			<img src="~/images/icon/tooltip-icon.png" style="margin-left: 10px;cursor:pointer">
		</el-tooltip>
	</div>
</template>
<script>
export default {
	name: 'IconTip',
	data () {
		return {
		}
	},
	created () {

	},
	methods: {

	}
}
</script>
<style lang="stylus" scoped>

</style>
